// extracted by mini-css-extract-plugin
module.exports = {"root":"RetailersBlok_root__Miv5c","retailers":"RetailersBlok_retailers__vi92g"};